import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=9b56f1a4&"
import script from "./FiltersBar.vue?vue&type=script&lang=js&"
export * from "./FiltersBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports